// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__OHUQC","log":"ModalInventoryLogs_log__3cjdS","date":"ModalInventoryLogs_date__rpr0J","userName":"ModalInventoryLogs_userName__2PcdD"};